import React, { memo, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDeleteAddressMutation } from '../../../../apis/mlkApi/mlk.api.hooks';
import { parseRes } from '../../../../apis/utils';
import { ModalRef } from '../../../../components/Modal/Modal';
import { SeparatorLine } from '../../../../components/SeparatorLine/SeparatorLine';
import { useLanguage } from '../../../../locale/useLanguage';
import { AddressType } from '../../../../models';
import { Routes } from '../../../../routes/types';
import { RemoveModal } from '../RemoveModal/RemoveModal';

import './AddressElement.css';

type AddressElementProps = {
  addressId: number;
  addressType: string;
  addressName: string;
  addressFirstPart: string;
  addressSecondPart: string;
};

export const AddressElement: React.FC<AddressElementProps> = memo(
  ({
    addressFirstPart,
    addressName,
    addressSecondPart,
    addressType,
    addressId,
  }) => {
    const [t] = useLanguage();
    const history = useHistory();

    const modalRef = useRef<ModalRef>(null);

    const goToEditAddress = useCallback(() => {
      history.push(Routes.EditAddress.replace(':addressId', `${addressId}`));
    }, [addressId, history]);

    const closeModal = useCallback(() => {
      modalRef.current?.closeModal();
    }, []);

    const openModal = useCallback(() => {
      modalRef.current?.openModal();
    }, []);

    const [deleteAddress] = useDeleteAddressMutation();

    const onDeleteAddress = useCallback(() => {
      modalRef.current?.closeModal();
      deleteAddress(`${addressId}`).then((res) => {
        const { errorRes } = parseRes(res);
        if (errorRes.error) {
          // TODO: Handle res error
          console.log(errorRes.error);
        }
      });
    }, [addressId, deleteAddress]);

    return (
      <>
        <div className="address-line--container">
          <p className="address-line--address-type">
            {addressType === AddressType.Private
              ? t('addressNotesView.addressTypePrivate')
              : t('addressNotesView.addressTypeCompany')}
          </p>
          <h2 className="address-line--title">{addressName}</h2>
          <p className="address-line--address">
            {addressFirstPart} {addressSecondPart}
          </p>
          <a className="link" onClick={goToEditAddress}>
            {t('addresses.edit')}
          </a>
          <a className="link address-line--delete" onClick={openModal}>
            {t('addresses.delete')}
          </a>
        </div>
        <RemoveModal
          ref={modalRef}
          onClose={closeModal}
          onRemove={onDeleteAddress}
        />
        <SeparatorLine />
      </>
    );
  }
);
